import { Component, Input, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-profile-avatar",
	templateUrl: "profile-avatar.component.html",
})
export class ProfileAvatarComponent implements OnInit {
	@Input() image = null;
	@Input() nom: string;
	protected backendURL = environment.backendURL;
	protected avatarImageUrl;
	constructor() {}

	ngOnInit() {
		if (this.image != null) {
			this.avatarImageUrl = this.backendURL + this.image;
		}
	}
    onImageError() {
	this.avatarImageUrl = "./assets/images/users/avatar.jpg";
}

}
